import React from 'react';
import PropTypes from 'prop-types';

const Marker01 = ({color = 'currentColor', ...props}) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 18 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.5 16H5.59091M3.54545 8.82609V1H16.5L14.4545 4.91304L16.5 8.82609H3.54545ZM3.54545 8.82609V15.3478"
      stroke={color}
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

Marker01.propTypes = {
  color: PropTypes.string,
};

export default Marker01;
